function BlockToolbar({

  addBlock

}) {

  return (

    <div
      className="block-toolbar"
    >

      <button
        onClick={() =>
          addBlock("title1")
        }
      >

        + Titre 1

      </button>

      <button
        onClick={() =>
          addBlock("title2")
        }
      >

        + Titre 2

      </button>

      <button
        onClick={() =>
          addBlock("paragraph")
        }
      >

        + Paragraphe

      </button>

      <button
        onClick={() =>
          addBlock("table")
        }
      >

        + Tableau

      </button>

    </div>

  );

}

export default BlockToolbar;